import { render, staticRenderFns } from "./TopNavBar.vue?vue&type=template&id=87cbc91c&scoped=true&"
import script from "./TopNavBar.vue?vue&type=script&lang=js&"
export * from "./TopNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavBar.vue?vue&type=style&index=0&id=87cbc91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cbc91c",
  null
  
)

export default component.exports